import React from "react";
import Flagship from "../../core/flagship";
import { Link } from "react-router";
import { Dropdown, Segment, Button, Icon, Divider } from "semantic-ui-react";
import { throttle, empty } from "../../utils/helpers";

class RfpField extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  getInitialState() {
    return {
      searchResults: [],
    };
  }

  searchRfps(like) {
    let self = this;

    Flagship.get(
      "dropdown-search/rfp",
      {
        search: like,
      },
      function (response) {
        if (response.data.success === true) {
          self.setState({
            searchResults: response.data.results,
          });
        } else {
          Flagship.error(
            "Could not retrieve dropdown search results for Rfp field. Query: " +
              like,
            0,
            0
          );
        }
      },
      function (err) {
        Flagship.error("An error occurred in dropdown search: " + err, 0, 0);
      }
    );
  }

  onSearchChange(e, data) {
    let search = this.searchRfps.bind(this);
    this.timer = throttle(
      function () {
        search(data);
      },
      400,
      this.timer
    );
  }

  render() {
    if (!empty(this.props.value)) {
      return (
        <div>
          <Segment compact>
            <h3 className="attachment-record-link">
              <Icon
                className="feed-icon"
                disabled
                size="large"
                color="grey"
                name="dollar"
              />
              {this.props.value.id === 1 ? (
                <div
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Proposal in Advisr
                  <br />
                  <small>Not tied to a Flagship RFP.</small>
                </div>
              ) : (
                <Link
                  style={{ display: "inline-block", verticalAlign: "middle" }}
                  to={"/rfp/view/" + this.props.value.key}
                >
                  {this.props.value.name}
                </Link>
              )}
            </h3>
            <Divider hidden />
            <Button
              secondary
              onClick={this.props.onReset}
              content="Change..."
            />
          </Segment>
        </div>
      );
    }

    return (
      <div>
        <Dropdown
          {...this.props}
          fluid
          search
          selection
          onSearchChange={this.onSearchChange}
          options={this.state.searchResults}
        />
        <small>Note: Only closed RFPs or Advisr may be selected here.</small>
      </div>
    );
  }
}

export default RfpField;



// WEBPACK FOOTER //
// ./src/components/misc/RfpField.js